<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card ref="filterCard" :title="$t('general.filters')" class="user-list-filters mb-8" collapse-action>
        <div class="flex mb-5">
          <div class="w-1/6 px-2">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.contractNo") }}</label>
            <vs-input type="text" v-model="form.contractNo" class="w-full" v-on:keyup.enter="onEnter()"/>
          </div>
          <div class="w-1/6 px-2">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.contractName") }}</label>
            <vs-input type="text" v-model="form.contractName" class="w-full" v-on:keyup.enter="onEnter()"/>
          </div>
          <div class="w-1/6 px-2">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.project") }}</label>
            <v-select v-model="form.project" :clearable="true" :options="projectOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="flex-1 px-2">
            <label class="text-sm opacity-75">{{$t('sections.accounting.dataForm.faculty')}}/{{$t('sections.accounting.dataForm.curriculum')}}</label>
            <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" name="curriculum" :reduce="res => res.value" disalbed />
          </div>
          <div class="flex-1 px-2">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.loan.loanType") }}</label>
            <v-select v-model="form.loanType" :clearable="true" :options="loanTypesOptions" name="loanType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="flex">
          <div class="flex flex-1 px-2">
            <vs-button class="ml-auto mx-1" @click="search()">{{ $t("general.search") }}</vs-button>
            <vs-button type="border" class="mx-1" color="warning" @click="reset()">{{ $t("general.reset") }}</vs-button>
          </div>
        </div>
      </vx-card>
      <vx-card>
        <div class="flex">
          <div class="flex-1 px-2 pb-2">
            {{ $t("sections.accounting.dataForm.itemCounts", { max: contractsByFilters.length }) }}
          </div>
          <div class="flex-1"></div>
        </div>
        <vs-table :data="contractsByFilters" >
          <template slot="thead">
            <vs-th sort-key="loanType" class="w-1/6">{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
            <vs-th sort-key="loanType" class="w-1/6">{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
            <vs-th sort-key="loanType" class="w-1/6">{{ $t("sections.accounting.dataForm.project") }}</vs-th>
            <vs-th sort-key="loanType" class="w-1/6">{{ $t("sections.accounting.dataForm.faculty") }}/{{ $t("sections.accounting.dataForm.curriculum") }}</vs-th>
            <vs-th sort-key="loanType" class="w-1/6">{{ $t("sections.accounting.dataForm.loan.loanType") }}</vs-th>
            <vs-th sort-key="loanType" class="w-1/6"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="res" :key="indextr" v-for="(res, indextr) in data">
              <vs-td :data="res.contractNo">
                {{ res.contractNo }} <b><u>{{ res.contractSeq }}</u></b>
              </vs-td>
              <vs-td :data="res.contractName">
                {{ res.contractName }}
              </vs-td>
              <vs-td :data="project(res)">
                {{ project(res) }}
              </vs-td>
              <vs-td :data="curriculum(res)">
                {{ curriculum(res) }}
              </vs-td>
              <vs-td :data="res.loan.loanType">
                {{ res.loan.loanType | loanType}}
              </vs-td>
              <vs-td :data="res.contractName">
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('AccountingTransaction', 'edit', 'b')" @click="edit(res.id)"></vs-button>
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('AccountingTransaction', 'edit', 'b')" @click="view(res.id)"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createNamespacedHelpers, mapGetters } from 'vuex'
import vSelect from 'vue-select'
const moment = require('moment');
import { round } from '@/utils'
const {mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
const {mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect
  },
  data () {
    return {
      form:{
        project: "",
        loanType: "",
        curriculum: "",
        contractNo: "",
        contractName: "",
      },
      user: "",
      selected: [],
      loading: false
    }
  },
  async created () {
    const vm = this
    if(vm.$route.params.contractNo){
      await vm.initData({
        contractNo: vm.$route.params.contractNo
      });
    }else{
      await vm.initData();
    }
  },
  computed: {
    ...mapAccountingState([ 'status', 'contractsByFilters', 'contract', 'transactions']),
    ...mapMasterState(["curriculums", "transactionFilters"]),
    ...mapGetters({
      projectOptions: "Master/projectOptions",
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      loanTypesOptions: "Master/loanTypesOptions"
    }),
  },
  methods: {
    ...mapAccountingActions(['getContractsByFilters', 'getContract', 'getTransactionsByContractId', 'deleteTransactions', 'reGenerateTransactions', 'deletePaymentsByContractId']),
    ...mapMasterActions(['getProjects', 'getCurriculums', 'setTransactionFilters']),
    async onEnter(){
      this.search ()
    },
    async search (){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false

      await vm.setTransactionFilters({
        project: vm.form.project,
        loanType: vm.form.loanType,
        curriculum: vm.form.curriculum,
        contractNo: vm.form.contractNo,
        contractName: vm.form.contractName,
      });

      await vm.getContractsByFilters({
        form: {
          project: {id: vm.form.project || ''},
          loanType: vm.form.loanType || 'Null',
          curriculum: {id: vm.form.curriculum || ''},
          contractNo: vm.form.contractNo,
          contractName: vm.form.contractName,
        }
      })

      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async reset(){
      this.form = {
        project: "",
        loanType: "",
        curriculum: "",
        contractNo: "",
        contractName: "",
      }
      await this.search ()
    },
    async initData(args){
      const vm = this
      if(args){
        vm.form = {
          project: vm.transactionFilters ? vm.transactionFilters.project : "",
          loanType: vm.transactionFilters ? vm.transactionFilters.loanType : "",
          curriculum: vm.transactionFilters ? vm.transactionFilters.curriculum : "",
          contractNo: args.contractNo,
          contractName: vm.transactionFilters ? vm.transactionFilters.contractName : "",
        }
        await vm.search ()
      }else{
        vm.form = {
          project: vm.transactionFilters ? vm.transactionFilters.project : "",
          loanType: vm.transactionFilters ? vm.transactionFilters.loanType : "",
          curriculum: vm.transactionFilters ? vm.transactionFilters.curriculum : "",
          contractNo: vm.transactionFilters ? vm.transactionFilters.contractNo : "",
          contractName: vm.transactionFilters ? vm.transactionFilters.contractName : "",
        }
      }
    },
    async edit (id) {
      this.$router.push({ name: 'accounting-contract-detail', params: {id: id} })
    },
    async view (id) {
      this.$router.push({ name: 'accounting-transaction-view', params: {id: id} })
    },
    async viewEir (id) {
      this.$router.push({ name: 'accounting-transactionEir-view', params: {id: id} })
    },
    async reGenerate (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-reGenerate-title'),
        text: this.$t('notification.confirm-reGenerate-message'),
        accept: this.acceptReGenerateTransactions
      })
    },
    async del (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDel
      })
    },
    async acceptDel () {
      await this.deleteTransactions({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    async delPayments (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDelPayments
      })
    },
    async acceptDelPayments () {
      await this.deletePaymentsByContractId({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    async acceptReGenerateTransactions () {
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false

      await vm.reGenerateTransactions({
        form: {
          contractId: vm.actionID,
          updateToNow: false
        },
        vm: vm
      })

      await setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    project(res){
      let project = ""
      if(res.borrower){
        project = res.borrower.project.nameTh
      }
      return project
    },
    curriculum(res){
      let curriculum = ""
      if(res.curriculum){
        curriculum = res.curriculum.faculty.nameTh+'/'+res.curriculum.nameTh
      }
      return curriculum
    },
  },
  watch: {
    status: {
      handler(res){
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    }
  }
}
</script>
